import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { ExampleLines } from "../../flashcardUtils";
import PronunciationLine from "./PronunciationLine";

function WriteStage({
  practiceCard,
  practiceMeta,
  practiceAnswer,
  practiceResult,
  onSetPracticeAnswer,
  onSetPracticeResult,
  onCheckPracticeAnswer,
  onAdvancePractice,
}) {
  return (
    <Grid container spacing={{ xs: 2.5, md: 2 }} alignItems="stretch">
      <Grid item xs={12} md={6}>
        <Box
          className="lingualica-scrollarea"
          sx={{
            height: "100%",
            minHeight: { xs: 220, md: 270 },
            maxHeight: { xs: 330, md: 310 },
            overflowY: "auto",
            p: { xs: 2.25, md: 2.4 },
            borderRadius: "20px",
            bgcolor: "#f7fff9",
            border: "1.5px dashed #b9e8cf",
          }}
        >
          <Typography sx={{ color: "#35a86a", fontSize: 13, fontWeight: 800, textTransform: "uppercase", mb: 1 }}>
            Meaning clue
          </Typography>
          <Typography sx={{ color: "var(--toeic-ink-deep)", fontSize: { xs: 23, md: 27 }, fontWeight: 800, lineHeight: 1.16 }}>
            {practiceCard.back}
          </Typography>
          {practiceCard.definition && practiceCard.definition !== practiceCard.back && (
            <Typography sx={{ mt: 1.5, color: "var(--toeic-ink)", fontSize: 15, fontWeight: 500, lineHeight: 1.5 }}>
              {practiceCard.definition}
            </Typography>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            height: "100%",
            minHeight: { xs: 220, md: 270 },
            p: { xs: 2.25, md: 2.4 },
            borderRadius: "20px",
            bgcolor: practiceMeta.surface,
            border: "1.5px dashed #d7eaf5",
            display: "grid",
            alignContent: "center",
            gap: 1.5,
          }}
        >
          <Typography sx={{ color: practiceMeta.accent, fontSize: 13, fontWeight: 800, textTransform: "uppercase" }}>
            Type the word
          </Typography>
          <TextField
            value={practiceAnswer}
            onChange={(event) => {
              onSetPracticeAnswer(event.target.value);
              onSetPracticeResult(null);
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter" && practiceAnswer.trim()) {
                event.preventDefault();
                practiceResult === null ? onCheckPracticeAnswer() : onAdvancePractice();
              }
            }}
            autoFocus
            placeholder="Your answer"
            fullWidth
            inputProps={{
              autoCapitalize: "none",
              autoCorrect: "off",
              spellCheck: "false",
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
                bgcolor: "#fffefd",
                fontSize: { xs: 24, md: 26 },
                fontWeight: 700,
              },
            }}
          />
          {practiceResult !== null && (
            <Box
              sx={{
                p: 1.5,
                borderRadius: "16px",
                bgcolor: practiceResult ? "#eefbf3" : "#fff3f5",
                border: `1px solid ${practiceResult ? "#b9e8cf" : "#ffd1dc"}`,
              }}
            >
              <Typography sx={{ color: practiceResult ? "#238653" : "#c21d4f", fontSize: 14, fontWeight: 800 }}>
                {practiceResult ? "Correct" : `Answer: ${practiceCard.front}`}
              </Typography>
              {practiceResult && practiceCard.example && (
                <Box sx={{ mt: 1 }}>
                  <Typography sx={{ color: "var(--toeic-ink-soft)", fontSize: 11, fontWeight: 800, textTransform: "uppercase", mb: 0.5 }}>
                    Examples
                  </Typography>
                  <ExampleLines example={practiceCard.example} term={practiceCard.front} />
                </Box>
              )}
              {!practiceResult && (
                <Typography sx={{ mt: 0.25, color: "var(--toeic-ink-soft)", fontSize: 12.5, fontWeight: 500 }}>
                  This word will return in a shuffled review round.
                </Typography>
              )}
              <PronunciationLine card={practiceCard} accent={practiceMeta.accent} compact />
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}

export default WriteStage;
